module.exports = __webpack_public_path__ + "img/Design.870f2aad.png";